export enum enumAdsConsumerLeadsStatusType {
    NewLeadReceived = 1,
    OfferSent = 2,
    OfferAccepted = 3,
    Rejected = 4,
    Unreached = 5,
    CustomerCallPending = 6
};